class TgStore {
  constructor(initialState = {}) {
    this._stores = {};
    this._state = {};
    this._proxyState = {};

    this._listeners = new Map();

    const self = this;

    Object.entries(initialState).forEach(([key, value]) => {
      Object.defineProperty(this._proxyState, key, {
        get() {
          return self._state[key];
        },
        set(v) {
          let prev = self._state[key];
          if(prev !== v) {
            self._state[key] = v;
            self.$emit(`update:${key}`, v, prev);
          }
        }
      });

      Object.defineProperty(this, key, {
        get() {
          return self._proxyState[key];
        },
        set(v) {
          self._proxyState[key] = v;
        }
      });

      self._state[key] = value;
    })
  }

  get state() {
    return this._proxyState;
  }

  get stores() {
    return this._stores;
  }

  $emit(event, ...args) {
    if(!this._listeners.has(event)) {
      return;
    }

    console.log(this._listeners.get(event));

    this._listeners.get(event).forEach(cb => cb(...args));
  }

  $on(event, cb) {
    if(!this._listeners.has(event)) {
      this._listeners.set(event, new Set());
    }

    this._listeners.get(event).add(cb);
  }

  createStore(name, initialState = {}) {
    this._stores[name] = new TgStore(initialState);
  }
}


const store = new TgStore({
  isInit: false,
});

store.createStore('chats', {
  activeChatId: null,
  chats: [],
});

store.createStore('files', {
  files: [],
});

export default store;
